import { Component } from "react";
import { APP_CONSTANTS, APP_CONFIG, API_CONSTANTS } from '../global/Constants';
import Utilities from "../global/Utilities";
import { CryptoService } from "./CryptoService";

const isEncrypt = true;

export default class AuthService extends Component {
    static mInstance = null;
    static keyName = APP_CONSTANTS.APP_USER;

    static getInstance() {
        if (AuthService.mInstance == null) {
            AuthService.mInstance = new AuthService();
        }
        return this.mInstance;
    }

    static setSession(key, item) {
        localStorage.setItem(key, item);
        this.setToken(API_CONSTANTS.ACCESS_TOKEN);

        //localStorage.setItem(key, JSON.stringify(item));

        // if (isEncrypt) {
        //     var encrypted = CryptoService.encryptData(APP_CONFIG.USER_KEY, item);
        //     localStorage.setItem(key, encrypted);
        // } else {
        //     localStorage.setItem(key, JSON.stringify(item));
        // }
    }

    static getSession(key = this.keyName) {
        // const item = JSON.parse(localStorage.getItem(key));
        // return item;

        if (isEncrypt) {
            var decrypted = CryptoService.decryptData(APP_CONFIG.USER_KEY, localStorage.getItem(key));
            const item = decrypted;
            return item;

        } else {
            const item = JSON.parse(localStorage.getItem(key));
            return item;
        }
    }

    static clearSession() {
        //localStorage.clear();
        localStorage.removeItem(APP_CONSTANTS.APP_USER);
        return true;
    }

    static getRoleAccess = (key) => {
        const session = AuthService.getSession(APP_CONSTANTS.APP_USER);
        if (session != null) {
            return session?.user?.user_access_privileges[key];
        }
    }

    static setToken = (key) => {
        const session = AuthService.getSession(APP_CONSTANTS.APP_USER);
        Utilities.LogPrint("LOGGED USER", session);
        if (session != null) {
            localStorage.setItem(key, "Bearer " + session?.token);
        }
    }

    static isVcUser = () => {
        let vc = false;
        const session = AuthService.getSession(APP_CONSTANTS.APP_USER);
        if (session) {
            const user = session.user;
            if (user?.is_vc) {
                vc = user.is_vc;
            }
        }
        return vc;
    }
}